import { useState ,useRef} from "react";
import { colorClasses } from "../../utils";
import Feedback from "../Feedback";
import ActionButtons from "../ActionButtons";
import correct from "../../assets/sounds/correct.wav"
import wrong from "../../assets/sounds/wrong.wav"
import retry from "../../assets/sounds/retry.wav"
import check from "../../assets/sounds/check.wav"
const MultiSelectExercise = ({ exercise }) => {
  const [state, setState] = useState(Array(exercise.items.length).fill(false));
  const [feedback, setFeedback] = useState(null);
  const correctSound = useRef(new Audio(correct))
  const wrongSound = useRef(new Audio(wrong))
  const retrySound = useRef(new Audio(retry))
  const checkSound = useRef(new Audio(check))
  const handleClick = (index) => {
    checkSound.current.currentTime = 0;
    checkSound.current.play();
    const newState = [...state];
    newState[index] = !newState[index];
    checkSound.current.currentTime = 0;
    checkSound.current.play();
    setState(newState);
    setFeedback(null);
  };

  const handleCheck = () => {
    const isCorrect = state.every((selected, i) => selected === exercise.items[i].correct);
    if(isCorrect){
        correctSound.current.currentTime = 0;
        correctSound.current.play()
    }else{
        wrongSound.current.currentTime = 0;
        wrongSound.current.play()
    }
    setFeedback({
      type: isCorrect ? 'success' : 'error',
      message: isCorrect ? exercise.successMessage : exercise.errorMessage
    });
  };

  const handleReset = () => {
    retrySound.current.currentTime = 0;
    retrySound.current.play()
    setState(Array(exercise.items.length).fill(false));
    setFeedback(null);
  };

  return (
    <>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-5">
        {exercise.items.map((item, idx) => (
          <div
            key={idx}
            onClick={() => handleClick(idx)}
            className={`border-2 sm:border-4 rounded-xl sm:rounded-2xl p-3 sm:p-5 text-center cursor-pointer transition-all hover:scale-105 ${
              state[idx]
                ? 'border-green-500 bg-green-50'
                : 'border-gray-500 bg-white'
            }`}
          >
            <div className="text-5xl sm:text-7xl mb-2">{item.emoji}</div>
            <div className="font-bold text-sm sm:text-lg mb-2">{item.label}</div>
            <div className={`w-8 h-8 sm:w-10 sm:h-10 border-2 sm:border-4 rounded-lg mx-auto flex items-center justify-center text-xl sm:text-2xl ${
              state[idx] ? 'border-green-500 bg-green-500 text-white' : 'border-gray-500 bg-white'
            }`}>
              {state[idx] ? '✓' : ''}
            </div>
          </div>
        ))}
      </div>
      <ActionButtons onCheck={handleCheck} onReset={handleReset} />
      <Feedback feedback={feedback} />
    </>
  );
};

export default MultiSelectExercise